import { Component, Input } from '@angular/core';
import { NgClass, SlicePipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface TsAvatar {
  imageSrc: string;
  name: string;
}

@Component({
  selector: 'ts-avatar-group',
  standalone: true,
  imports: [NgClass, SlicePipe, MatTooltipModule],
  templateUrl: './ts-avatar-group.component.html',
})
export class TsAvatarGroupComponent {
  @Input({ required: true }) avatars: TsAvatar[] = [];
  @Input() maxAvatars = 4;

  get hasMaxNumberOfAvatars() {
    return this.avatars?.length > this.maxAvatars;
  }

  get avatarsCountAfterTheFourth() {
    if (this.hasMaxNumberOfAvatars) return this.avatars.length - this.maxAvatars;

    return 0;
  }
}
